import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { Snackbar } from '@mui/material';

type SnackbarMessage = {
  text: string;
  open: boolean;
};

interface SnackbarContextProps extends PropsWithChildren {
  pushMessage: (message: string) => void;
}

export const SnackbarContext = createContext<SnackbarContextProps>({} as SnackbarContextProps);

export const useSnackbarContext = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbarContext must be used within a SnackbarProvider');
  }
  return context;
};

const SnackbarProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [messages, setMessages] = useState<SnackbarMessage[]>([]);

  const pushMessage = (message: string) => {
    const newMessage: SnackbarMessage = { text: message, open: true };
    setMessages((messages) => [...messages, newMessage]);
    setTimeout(() => {
      setMessages((messages) => {
        const newMessages = [...messages];
        newMessages[newMessages.indexOf(newMessage)].open = false;
        return newMessages;
      });
    }, 5000);
  };

  return (
    <SnackbarContext.Provider value={{ pushMessage }}>
      {children}
      <div className="custom-snackbars-container">
        {messages.map((message, index) => (
          <Snackbar
            className="custom-snackbar"
            key={index}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={message.open}
            message={message.text}
          />
        ))}
      </div>
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
